<template>
  <div id="basket">
    <Row style="background: rgb(246, 246, 246);padding: 0.5em;">
      <i-col style="text-align: left">
        <router-link to="/">
          <Icon
            :size="44"
            color="blue"
            type="ios-arrow-round-back" />
        </router-link>
      </i-col>
    </Row>
    <div v-if="basket_id === ''">
      <Row row>
        <i-col
          v-for="(plate, id) in plates"
          :key="plate.uid + 'plate'"
          :md="12"
          style="padding:5px"
        >
          <div class="item">
            <Row
            ><h4 style="text-align: right;padding: 10px 5px">
              {{ plate.name }}
            </h4></Row
            >
            <Row justify="end">
              <i-col
                :md="16"
                :xs="24">
                <div class="content">
                  <Row>
                    <i-col>
                      <Row style="text-align: right">
                        <i-input
                          v-model.number="plates[id].quantity"
                          label="تعداد"
                          min="1"
                          type="number"
                          @on-change="changeVariant(id)"
                        />
                      </Row>
                      <Row style="text-align: right">
                        قیمت واحد: {{ moneyFormat(basePrice(plate)) }} تومان
                      </Row>
                      <br >
                      <CheckboxGroup
                        v-model="plates[id].additional_parameters"
                        @on-change="changeVariant(id)"
                      >
                        <Checkbox
                          v-for="add in getAdditionals(plate)"
                          :key="plate.uid + add.ad_id"
                          :label="add.ad_id"
                          border
                        ><span>{{ add.title }}</span></Checkbox
                        >
                      </CheckboxGroup>
                      <br >
                      <b>جمع کل: {{ moneyFormat(totalPrice(plate)) }} تومان</b>
                    </i-col>
                  </Row>
                </div>
              </i-col>
              <i-col
                :md="8"
                :xs="24"
                style="text-align: center">
                <img
                  :src="
                    `https://chapchi.com/api/designer/render/` +
                      plate.uid +
                      `/` +
                      plate.sides_data[0].id +
                      `/` +
                      getFirstMock(plate)
                  "
                  class="mock-render"
                >
              </i-col>
            </Row>
          </div>
        </i-col>
      </Row>
      <divider />
      <div v-if="reseller">
        <Row>
          <Select
            v-model="rsf.shop_id"
            label="لیبل ارسال"
          >
            <Option
              v-for="st in stores"
              :key="`stt` + st.shop_id"
              :value="st.shop_id"
            >{{ st.shop_name }}</Option>
          </Select>
        </Row>
        <Row>
          <Select
            v-model="rsf.gateway"
            label="شیوه‌ی ارسال"
            @input="calcTransport"
          >
            <Option
              v-for="dg in delivery_gateways"
              :key="`dg` + dg.d_id"
              :value="dg.d_id"
            >{{ dg.title }}
            <span v-if="dg.d_id === 4">(یا سایر روش‌ها)</span></Option
            >
          </Select>
        </Row>
        <Row style="padding: 10px">
          <i-col
            :md="8"
            :xs="8">
            <Input
              v-model="rsf.receiver"
              maxlength="32"
              placeholder="نام گیرنده"
            ></Input>
          </i-col>
          <i-col
            :md="8"
            :xs="8">
            <Select
              v-model="rsf.city"
              label="شهر"
              @input="calcTransport">
              <Option
                v-for="ct in p_city"
                :key="`ct_` + ct.id"
                :value="ct.id"
              >{{ ct.name }}</Option
              >
            </Select>
          </i-col>
          <i-col
            :md="8"
            :xs="8">
            <Select
              v-model="rsf.province"
              label="استان">
              <Option
                v-for="pv in provinces"
                :key="`pv` + pv.id"
                :value="pv.id"
              >{{ pv.name }}</Option
              >
            </Select>
          </i-col>
        </Row>

        <Row style="padding: 10px">
          <i-col
            :md="8"
            :xs="8">
            <Input
              v-model="rsf.phone"
              maxlength="11"
              placeholder="تلفن گیرنده"
            ></Input>
          </i-col>
          <i-col
            :md="8"
            :xs="8">
            <Input
              v-model="rsf.postal"
              maxlength="10"
              placeholder="کد پستی"
            ></Input>
          </i-col>
          <i-col
            :md="8"
            :xs="8">
            <Input
              v-model="rsf.address"
              maxlength="255"
              placeholder="آدرس گیرنده"
            ></Input>
          </i-col>
        </Row>

        <Row>
          <card>
            <Input
              v-model="rsf.description"
              :autosize="{ minRows: 2, maxRows: 5 }"
              type="textarea"
              maxlength="255"
              style="margin-bottom: 10px"
              placeholder="توضیحات"
            ></Input>
            <br >
            <b v-if="loadTransport === false">
              هزینه حمل:
              {{ (transport_cost > 0?moneyFormat(transport_cost) + ' تومان': 'رایگان') }}
              ، جمع کل:
              {{ moneyFormat(totalBasket) }}
              تومان
              <span
                v-if="reseller_data.balance / 10 < totalBasket"
                style="color: red"
              >
                (
                {{ moneyFormat(reseller_data.balance / 10 - totalBasket) }}
                کسری موجودی )
              </span>
            </b>
          </card>
        </Row>
      </div>

      <Row style="padding: 10px">
        <a
          v-if="reseller === false"
          href="/customer/basket">
          <Button
            type="success"
            size="large"
            style="width:100%">
            <Icon
              color="white"
              size="22"
              type="ios-arrow-round-forward" />
            ادامه
          </Button>
        </a>
        <Button
          v-else
          :loading="rsLoading"
          type="success"
          size="large"
          style="width:100%"
          @click="resellerSubmit"
        >
          <Icon
            color="white"
            size="22"
            type="ios-basket-outline" />
          ثبت سفارش
        </Button>
      </Row>
    </div>
    <div v-else>
      <Card>
        <p>
          <Alert type="success">
            خرید شما با موفقیت انجام شد.
            <template slot="desc">
              شماره خرید: {{ basket_id }}
              |
              <a href="/panel#/pages/reports/list/my_orders">بازگشت به پنل
                <Icon
                  :size="16"
                  color="blue"
                  type="ios-arrow-round-back" />
              </a>
            </template>
          </Alert>
        </p>
      </Card>
    </div>
    <Modal
      v-model="payment_modal"
      title="پرداخت"
      @on-ok="doPayment"
      @on-cancel="payment_modal = false">
      <p>
        <Input
          v-model.number="payment.amount"
          maxlength="10"
          placeholder="مبلغ"
          style="direction: ltr"
        ></Input>
        {{ Num2persian(payment.amount/10) }} {{ payment.amount > 0?' تومان':'' }}
        <br>
        <Select
          v-model="payment.gateway_id"
          label="درگاه"
        >
          <Option
            v-for="dg in payment_gateways"
            :key="`pp` + dg.id"
            :value="dg.id"
          >{{ dg.name }}</Option>
        </Select>
        <br>
        <Alert type="info">
          بعد از افزایش موجودی در صفحه‌ی جدید، مجددا بر روی دکمه‌ی ثبت سفارش کلیک کنید.
        </Alert>

      </p>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'Basket',
  data () {
    return {
      href: '',
      reseller: false,
      rsLoading: false,
      loadTransport: false,
      transport_cost: 0,
      reseller_data: { balance: 0 },
      delivery_gateways: [],
      provinces: [],
      cities: [],
      stores: [],
      plates: [],
      price_list: [],
      additional: [],
      stock: [],
      delivery: [],
      delivery_cities: [],
      gateways: [],
      sides: [],
      mocks: [],
      transportCost: 0,
      payment_gateways: [],
      form: {
        address: 0,
        gateway: 0,
        delivery: 0,
        description: ''
      },
      rsf: {
        gateway: 2,
        province: 0,
        shop_id: 0,
        city: 0,
        address: '',
        phone: '',
        receiver: '',
        postal: '',
        description: ''
      },
      basket_id: '',
      payment_modal: false,
      payment: {
        amount: 0,
        gateway_id: 0,
        callback: '/designer/?reseller=#/basket'
      },
      login: false,
      loginRequired: false
    }
  },
  computed: {
    totalBasket () {
      let total = 0

      this.plates.forEach(p => {
        let base = this.platePrice(p, this.sides, this.price_list)
        if (base > 0 && p.quantity > 0) {
          total += base * p.quantity
        }
      })
      return total + this.transport_cost
    },
    p_city () {
      let validCities = []
      this.delivery_gateways
        .filter(dg => dg.d_id === this.rsf.gateway)
        .forEach(dg => {
          dg.cities.forEach(dgc => {
            validCities.push(dgc.city_id)
          })
        })
      return this.cities.filter(
        c =>
          c.vip_province_id === this.rsf.province &&
          validCities.indexOf(c.id) > -1
      )
    }
  },
  mounted () {
    if (window.location.search.indexOf('reseller') > -1) {
      this.reseller = true

      this.fetchData('/reseller/z_province/').then(p => {
        this.provinces = p
      })
      this.fetchData('/reseller/z_city/').then(c => {
        this.cities = c
      })

      this.axios
        .get('/gateways/')
        .then(response => {
          this.payment_gateways = response.data.filter(d => d.gateway_type !== 'ZZ')
          this.payment.gateway_id = this.payment_gateways[0].id
        })
      this.getDeliveries()
      this.getResellerData()
    }
    // get price_list
    this.axios
      .get('/designer/data' + (this.reseller ? '?reseller=1' : ''))
      .then(response => {
        this.price_list = this.reseller
          ? response.data.rp_list
          : response.data.price_list
        this.stock = response.data.stock
        this.delivery = response.data.delivery
        this.delivery_cities = response.data.delivery_cities
        this.gateways = response.data.gateways
        this.form.gateway = this.gateways.length > 0 ? this.gateways[0].id : 0
        this.additional = response.data.additional.map(ad => {
          ad.colors =
            ad.colors.length > 0
              ? ad.colors.split(',').map(i => Number(i))
              : []
          ad.sizes =
            ad.sizes.length > 0 ? ad.sizes.split(',').map(i => Number(i)) : []
          ad.types =
            ad.types.length > 0 ? ad.types.split(',').map(i => Number(i)) : []
          return ad
        })
        this.sides = response.data.sides
        this.loadMocks()
      })
      .catch(() => {
        this.showError('خطا در ارتباط، صفحه را مجددا بارگذاری کنید')
      })
  },
  methods: {
    resellerSubmit () {
      if (this.rsf.gateway === 4) {
        this.rsf.city = 118
      }
      this.rsLoading = true

      this.axios
        .post('/reseller/submit_custom_basket', this.rsf, {
          headers: {
            Authorization:
              'Bearer ' + window.localStorage.getItem('default_auth_token')
          }
        })
        .then(response => {
          this.basket_id = response.data
        })
        .catch(error => {
          if (error.response.status === 418) {
            this.$Message.info('پرداخت الزامیست')
            this.payment_modal = true
            this.payment.amount = Number(error.response.data.content)
          }
        }).finally(() => {
          this.rsLoading = false
        })
    },
    calcTransport () {
      if (this.rsf.gateway === 4) {
        this.rsf.city = 118
      }
      this.loadTransport = true
      this.axios
        .post('/reseller/calc_transportation_cost', {
          gateway: this.rsf.gateway,
          city_id: this.rsf.city,
          total: this.totalBasket
        }, {
          headers: {
            Authorization:
              'Bearer ' + window.localStorage.getItem('default_auth_token')
          }
        })
        .then(response => {
          this.transport_cost = response.data.transportation_cost / 10
        })
        .catch(error => {
          this.showError(error)
        }).finally(() => {
          this.loadTransport = false
        })
    },
    getResellerData () {
      this.axios
        .get('/reseller/who_am_i', {
          headers: {
            Authorization:
              'Bearer ' + window.localStorage.getItem('default_auth_token')
          }
        })
        .then(response => {
          this.reseller_data = response.data
          this.getResData()
        })
        .catch(error => {
          this.rsLoading = true
          this.showError(error)
        })
    },
    getDeliveries () {
      this.axios
        .get('/reseller/delivery_gateways/', {
          headers: {
            Authorization:
              'Bearer ' + window.localStorage.getItem('default_auth_token')
          }
        })
        .then(response => {
          this.delivery_gateways = response.data.filter(d => d.d_id !== 3)
        })
        .catch(error => {
          this.showError(error)
        })
    },
    async getResData () {
      if (this.stores.length > 0) {
        return this.processOrder()
      }

      this.fetchData('/reseller/stores/')
        .then(data => {
          if (data.length === 0) {
            this.showError('برای ثبت سفارش میبایست حداقل یک فروشگاه ثبت کنید')
          } else {
            this.stores = data
            this.rsf.shop_id = this.stores[0].shop_id
            this.processOrder()
          }
        })
        .catch(error => {
          this.showError(error)
        })
    },
    processOrder () {},
    loadMocks () {
      // get mocks
      this.axios
        .get('/designer/mocks')
        .then(response => {
          this.mocks = response.data
          this.loadPlate()
        })
        .catch(() => {
          this.showError('خطا در ارتباط، صفحه را مجددا بارگذاری کنید')
        })
    },
    loadPlate () {
      // get mocks
      this.axios
        .get('/designer/plates')
        .then(response => {
          this.plates = response.data.map(pl => {
            pl.sides = pl.sides.split(',').map(a => Number(a))
            pl.additional_parameters =
              pl.additional_parameters.length > 0
                ? pl.additional_parameters.split(',').map(i => Number(i))
                : []
            return pl
          })
        })
        .catch(() => {
          this.showError('خطا در ارتباط')
        })
    },
    getAdditionals (plate) {
      return this.additional.filter(
        ad =>
          plate.blanks_id === ad.blanks_id &&
          (ad.colors.length === 0 || ad.colors.includes(plate.color_id)) &&
          (ad.types.length === 0 || ad.types.includes(plate.blanks_type)) &&
          (ad.sizes.length === 0 || ad.sizes.includes(plate.blanks_size))
      )
    },
    getFirstMock (plate) {
      let m = this.mocks.find(
        mock =>
          mock.side === plate.sides_data[0].id &&
          mock.color_id === plate.color_id &&
          mock.size_id === plate.blanks_size &&
          mock.type_id === plate.blanks_type &&
          mock.blanks_id === plate.blanks_id
      )
      if (typeof m === 'undefined') {
        return 0
      }
      return m.id
    },
    basePrice (plate) {
      return this.platePrice(plate, this.sides, this.price_list)
    },
    totalPrice (plate) {
      let base = this.platePrice(plate, this.sides, this.price_list)
      if (base <= 0 || plate.quantity <= 0) {
        return 'نامشخص'
      }
      return base * plate.quantity + ' تومان'
    },
    changeVariant (id) {
      this.axios
        .put('/designer/plate', {
          uid: this.plates[id].uid,
          additional: this.plates[id].additional_parameters.join(','),
          quantity: this.plates[id].quantity
        })
        .catch(() => {
          this.showError('خطا در همگام‌سازی لایه‌ها با سرور')
        })
    },
    doPayment () {
      //
      this.axios
        .post('/reseller/deposit/', this.payment, {
          headers: {
            Authorization:
              'Bearer ' + window.localStorage.getItem('default_auth_token')
          }
        })
        .then(response => {
          window.open('/payment/' + response.data.content, '_blank').focus()
          this.payment_modal = false
        })
        .catch(error => {
          this.showError(error)
        })
    }
  }
}
</script>

<style scoped>
#basket {
  padding: 10px;
}

.item {
  border: 1px solid #eeeeee;
  border-radius: 5px;
  margin-top: 5px;
  box-shadow: 1px 1px 0 #eeeeee;
  padding: 5px 15px;
  box-sizing: border-box;
  display: table;
  width: 100%;
}

.mock-render {
  border-radius: 10px;
  margin: 0 auto;
}

.item:hover {
  background: #f6f6f6;
}

.item img {
  height: 180px;
  float: right;
}

.layer-img {
  height: 100%;
  float: left;
  box-shadow: 3px 3px 0 #cacaca;
}

.content {
  padding-right: 10px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Basket.vue